// Which backend this web build talks to. Mirrors utils/appEnv.js on mobile (IS_TEST_BUILD):
// a build is TEST when EXPO_PUBLIC_APP_ENV=test or its Firebase project is the TEST project.
// Both values come from the build-time env (import.meta.env), so a production build always reads false.
const TEST_FIREBASE_PROJECT_ID = "vibelink-dev";

function isTestEnv(env) {
  return env?.EXPO_PUBLIC_APP_ENV === "test" || env?.EXPO_PUBLIC_FIREBASE_PROJECT_ID === TEST_FIREBASE_PROJECT_ID;
}

export const IS_TEST_BUILD = isTestEnv(import.meta.env);
